import { offlineBalanceReducer } from "./offlineBalance"

export const account = (
  state = { transactions: {}, balances: {}, members: {} },
  action,
) => {
  const clone = { ...state }
  switch (action.type) {
    case "SET_BALANCES":
      const balances = {}
      action.payload.forEach((item) => {
        balances[item.accountType] = item
      })
      return {
        ...clone,
        balances,
      }
    case "SET_TYPE_BALANCES":
      return {
        ...clone,
        balances: {
          ...clone.balances,
          [action.payload.transactionType]: action.payload.data,
        },
      }
    case "SET_MEMBER_BALANCES":
      return {
        ...clone,
        members: {
          ...clone.members,
          [action.payload.memberId]: {
            ...(clone.members[action.payload.memberId] || {}),
            [action.payload.transactionType]: action.payload.data,
          },
        },
      }
    case "SET_MEMBER_ACCOUNTS":
      return {
        ...clone,
        members: action.payload,
      }
    default:
      return clone
  }
}

const initialStateV2 = {
  online: {
    transactions: {},
    balances: {},
    members: {},
  },
  offline: null, // Will hold a snapshot of the 'online' state plus offline transactions
}

export const accountV2 = (state = initialStateV2, action) => {
  // First, let the original reducer handle any actions to update the 'online' state
  const onlineState = account(state.online, action)

  const newState = {
    ...state,
    online: onlineState,
  }

  // Pass the entire new state to the offline reducer to handle offline-specific actions
  // This allows the offline reducer to initialize or update the 'offline' slice based on the 'online' slice if needed
  return offlineBalanceReducer(newState, action)
}
